export default __webpack_public_path__ + "static/2-d6d758d72592f39f1ea56fed0d0998fd.jpeg";